import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.orderStatusSection.title',
    defaultMessage: 'Status',
    description: 'Title of the status section',
  },
  overview: {
    isConfirmed: {
      id: 'pages.orderStatusSection.overview.isConfirmed',
      defaultMessage: 'Confirmed',
      description: 'Title of the order is confirmed status in the status section',
    },
    isAccepted: {
      id: 'pages.orderStatusSection.overview.isAccepted',
      defaultMessage: 'Accepted',
      description: 'Title of the order is accepted status in the status section',
    },
    isLocked: {
      id: 'pages.orderStatusSection.overview.isLocked',
      defaultMessage: 'Locked',
      description: 'Title of the order is locked status in the status section',
    },
    isFinished: {
      id: 'pages.orderStatusSection.overview.isFinished',
      defaultMessage: 'Finished',
      description: 'Title of the order is finished status in the status section',
    },
    createdAt: {
      id: 'properties.createdAt',
      defaultMessage: 'Created at',
      description: 'Title of the order created at property in the status section',
    },
    updatedAt: {
      id: 'properties.updatedAt',
      defaultMessage: 'Updated at',
      description: 'Title of the order updated at property in the status section',
    },
    lastAcceptedAt: {
      id: 'properties.lastAcceptedAt',
      defaultMessage: 'Last accepted at',
      description: 'Title of the order last accepted at property in the status section',
    },
    lastConfirmedAt: {
      id: 'properties.lastConfirmedAt',
      defaultMessage: 'Last confirmed at',
      description: 'Title of the order last confirmed at property in the status section',
    },
    client: {
      id: 'properties.client',
      defaultMessage: 'Client',
      description: 'Title of the order client property in the status section',
    },
    type: {
      id: 'properties.type',
      defaultMessage: 'Type',
      description: 'Title of the order type property in the status section',
    },
    reference: {
      id: 'properties.reference',
      defaultMessage: 'Reference',
      description: 'Title of the order reference property in the status section',
    },
    allocationProgress: {
      id: 'properties.allocationProgress',
      defaultMessage: 'Allocation progress',
      description: 'Title of the order allocation progress property in the status section',
    },
    billingProgress: {
      id: 'properties.billingProgress',
      defaultMessage: 'Billing progress',
      description: 'Title of the order billing progress property in the status section',
    },
    fulfilmentProgress: {
      id: 'properties.fulfilmentProgress',
      defaultMessage: 'Fulfilment progress',
      description: 'Title of the order fulfilment progress property in the status section',
    },
    orderTags: {
      id: 'properties.orderTags',
      defaultMessage: 'Order tags',
      description: 'Title of the order tags property in the status section',
    },
  },
  status: {
    yes: {
      id: 'pages.orderStatusSection.status.yes',
      defaultMessage: 'Yes',
      description: 'Title of the true status value in the status section',
    },
    no: {
      id: 'pages.orderStatusSection.status.no',
      defaultMessage: 'No',
      description: 'Title of the false status value in the status section',
    },
  },
};

export default defineMessages(translations);
